// extracted by mini-css-extract-plugin
export default {"paymentSection":"e1-z","disabled":"f1-z"};